import types from "./types";

export default (
  state = {
    isFetchingMeta: false,
    metaInfo: null,
    metaInfoError: "",

    isFetchingRequestCard: false,
    requestCard: null,
    requestCardError: "",

    isFetchingRequestMain: false,
    requestMain: null,
    requestMainError: "",

    isFetchingRequestPlan: false,
    requestPlan: null,
    requestPlanError: "",

    isFetchingRequestGroup: false,
    requestGroup: null,
    requestGroupError: "",

    isFetchingRequestProgram: false,
    requestProgram: null,
    requestProgramError: "",

    isFetchingRelRequestList: false,
    relRequestList: [],
    relRequestListError: "",

    isFetchingFilters: false,
    filters: null,
    filtersError: "",

    isFetchingRelStudentList: false,
    relStudentList: [],
    relStudentListError: "",

    isFetchingMatchPersonList: false,
    matchPersonList: [],
    matchPersonListError: "",

    isFetchingRequestWork: false,
    requestWork: null,
    requestWorkError: "",

    isFetchingWorkProcessList: false,
    processList: [],
    processListError: "",

    isFetchingWorkProcess: false,
    workProcess: null,
    workProcessError: "",

    isCreatingRequestProgram: false,
    createdRequestProgram: null,
    createRequestProgramError: "",

    isCreatingStudent: false,
    createdStudent: null,
    createStudentError: "",

    isCreatingPerson: false,
    createdPerson: null,
    createPersonError: "",

    isDeletingRequestProgram: false,
    deletedRequest: null,
    deleteRequestError: "",

    isCalculatingSimilarRequest: false,
    calcSimilarResult: null,
    calcSimilarError: ""
  }, action
) => {
  switch (action.type) {
    case types.GET_REQUEST_CARD_REQUEST:
      return {
        ...state,
        isFetchingRequestCard: action.isFetchingRequestCard
      };
    case types.GET_REQUEST_CARD_COMPLETED:
      return {
        ...state,
        isFetchingRequestCard: action.isFetchingRequestCard,
        requestCard: action.requestCard
      };
    case types.GET_REQUEST_CARD_ERROR:
      return {
        ...state,
        isFetchingRequestCard: action.isFetchingRequestCard,
        requestCardError: action.requestCardError
      };

    case types.GET_REQUEST_SYSTEM_REQUEST:
      return {
        ...state,
        isFetchingMeta: action.isFetchingMeta,
        createdStudent: action.createdStudent,
        isCreatingStudent: action.isCreatingStudent,
        createdPerson: action.createdPerson,
        isCreatingPerson: action.isCreatingPerson,
        isFetchingWorkProcess: action.isFetchingWorkProcess,
        workProcess: action.workProcess
      };
    case types.GET_REQUEST_SYSTEM_COMPLETED:
      return {
        ...state,
        isFetchingMeta: action.isFetchingMeta,
        metaInfo: action.metaInfo
      };
    case types.GET_REQUEST_SYSTEM_ERROR:
      return {
        ...state,
        isFetchingMeta: action.isFetchingMeta,
        metaInfoError: action.metaInfoError
      };

    case types.GET_REQUEST_MAIN_REQUEST:
      return {
        ...state,
        isFetchingRequestMain: action.isFetchingRequestMain,
        createdStudent: action.createdStudent,
        isCreatingStudent: action.isCreatingStudent,
        createdPerson: action.createdPerson,
        isCreatingPerson: action.isCreatingPerson,
        isFetchingWorkProcess: action.isFetchingWorkProcess,
        workProcess: action.workProcess
      };
    case types.GET_REQUEST_MAIN_COMPLETED:
      return {
        ...state,
        isFetchingRequestMain: action.isFetchingRequestMain,
        requestMain: action.requestMain
      };
    case types.GET_REQUEST_MAIN_ERROR:
      return {
        ...state,
        isFetchingRequestMain: action.isFetchingRequestMain,
        requestMainError: action.requestMainError
      };

    case types.GET_REQUEST_PLAN_CARD_REQUEST:
      return {
        ...state,
        isFetchingRequestPlan: action.isFetchingRequestPlan
      };
    case types.GET_REQUEST_PLAN_CARD_COMPLETED:
      return {
        ...state,
        isFetchingRequestPlan: action.isFetchingRequestPlan,
        requestPlan: action.requestPlan
      };
    case types.GET_REQUEST_PLAN_CARD_ERROR:
      return {
        ...state,
        isFetchingRequestPlan: action.isFetchingRequestPlan,
        requestPlanError: action.requestPlanError
      };

    case types.GET_REQUEST_GROUP_CARD_REQUEST:
      return {
        ...state,
        isFetchingRequestGroup: action.isFetchingRequestGroup
      };
    case types.GET_REQUEST_GROUP_CARD_COMPLETED:
      return {
        ...state,
        isFetchingRequestGroup: action.isFetchingRequestGroup,
        requestGroup: action.requestGroup
      };
    case types.GET_REQUEST_GROUP_CARD_ERROR:
      return {
        ...state,
        isFetchingRequestGroup: action.isFetchingRequestGroup,
        requestGroupError: action.requestGroupError
      };

    case types.GET_REQUEST_PROGRAM_CARD_REQUEST:
      return {
        ...state,
        isFetchingRequestProgram: action.isFetchingRequestProgram
      };
    case types.GET_REQUEST_PROGRAM_CARD_COMPLETED:
      return {
        ...state,
        isFetchingRequestProgram: action.isFetchingRequestProgram,
        requestProgram: action.requestProgram
      };
    case types.GET_REQUEST_PROGRAM_CARD_ERROR:
      return {
        ...state,
        isFetchingRequestProgram: action.isFetchingRequestProgram,
        requestProgramError: action.requestProgramError
      };

    case types.GET_RELATION_REQUESTS_LIST_REQUEST:
      return {
        ...state,
        isFetchingRelRequestList: action.isFetchingRelRequestList
      }

    case types.GET_RELATION_REQUESTS_LIST_COMPLETED:
      return {
        ...state,
        isFetchingRelRequestList: action.isFetchingRelRequestList,
        relRequestList: action.relRequestList
      }

    case types.GET_RELATION_REQUESTS_LIST_ERROR:
      return {
        ...state,
        isFetchingRelRequestList: action.isFetchingRelRequestList,
        relRequestListError: action.relRequestListError
      }

    case types.GET_RELATION_STUDENTS_LIST_REQUEST:
      return {
        ...state,
        isFetchingRelStudentList: action.isFetchingRelStudentList
      }

    case types.GET_RELATION_STUDENTS_LIST_COMPLETED:
      return {
        ...state,
        isFetchingRelStudentList: action.isFetchingRelStudentList,
        relStudentList: action.relStudentList
      }

    case types.GET_RELATION_STUDENTS_LIST_ERROR:
      return {
        ...state,
        isFetchingRelStudentList: action.isFetchingRelStudentList,
        relStudentListError: action.relStudentListError
      }

    case types.GET_REQUEST_WORK_INFO_REQUEST:
      return {
        ...state,
        isFetchingRequestWork: action.isFetchingRequestWork,
      };
    case types.GET_REQUEST_WORK_INFO_COMPLETED:
      return {
        ...state,
        isFetchingRequestWork: action.isFetchingRequestWork,
        requestWork: action.requestWork
      };
    case types.GET_REQUEST_WORK_INFO_ERROR:
      return {
        ...state,
        isFetchingRequestWork: action.isFetchingRequestWork,
        requestWorkError: action.requestWorkError
      };

    case types.GET_WORK_PROCESS_LIST_REQUEST:
      return {
        ...state,
        isFetchingWorkProcessList: action.isFetchingWorkProcessList
      };
    case types.GET_WORK_PROCESS_LIST_COMPLETED:
      return {
        ...state,
        isFetchingWorkProcessList: action.isFetchingWorkProcessList,
        processList: action.processList
      };
    case types.GET_WORK_PROCESS_LIST_ERROR:
      return {
        ...state,
        isFetchingWorkProcessList: action.isFetchingWorkProcessList,
        processListError: action.processListError
      };

    case types.CHANGE_WORK_STATE_REQUEST:
      return {
        ...state,
        isFetchingWorkProcess: action.isFetchingWorkProcess,
        workProcess: null,
        workProcessError: ""
      };
    case types.CHANGE_WORK_STATE_COMPLETED:
      return {
        ...state,
        isFetchingWorkProcess: action.isFetchingWorkProcess,
        workProcess: action.workProcess
      };
    case types.CHANGE_WORK_STATE_ERROR:
      return {
        ...state,
        isFetchingWorkProcess: action.isFetchingWorkProcess,
        workProcessError: action.workProcessError
      };

    case types.SET_REQUEST_PLAN_REQUEST:
      return {
        ...state,
        isFetchingWorkProcess: action.isFetchingWorkProcess
      };
    case types.SET_REQUEST_PLAN_COMPLETED:
      return {
        ...state,
        isFetchingWorkProcess: action.isFetchingWorkProcess,
        workProcess: action.workProcess
      };
    case types.SET_REQUEST_PLAN_ERROR:
      return {
        ...state,
        isFetchingWorkProcess: action.isFetchingWorkProcess,
        workProcessError: action.workProcessError
      };

    case types.SET_REQUEST_GROUP_REQUEST:
      return {
        ...state,
        isFetchingWorkProcess: action.isFetchingWorkProcess
      };
    case types.SET_REQUEST_GROUP_COMPLETED:
      return {
        ...state,
        isFetchingWorkProcess: action.isFetchingWorkProcess,
        workProcess: action.workProcess
      };
    case types.SET_REQUEST_GROUP_ERROR:
      return {
        ...state,
        isFetchingWorkProcess: action.isFetchingWorkProcess,
        workProcessError: action.workProcessError
      };

    case types.SET_REQUEST_PERSON_REQUEST:
      return {
        ...state,
        isFetchingWorkProcess: action.isFetchingWorkProcess
      };
    case types.SET_REQUEST_PERSON_COMPLETED:
      return {
        ...state,
        isFetchingWorkProcess: action.isFetchingWorkProcess,
        workProcess: action.workProcess
      };
    case types.SET_REQUEST_PERSON_ERROR:
      return {
        ...state,
        isFetchingWorkProcess: action.isFetchingWorkProcess,
        workProcessError: action.workProcessError
      };

    case types.CREATE_REQUEST_STUDENT_REQUEST:
      return {
        ...state,
        isCreatingStudent: action.isCreatingStudent
      }

    case types.CREATE_REQUEST_STUDENT_COMPLETED:
      return {
        ...state,
        isCreatingStudent: action.isCreatingStudent,
        createdStudent: action.createdStudent
      }

    case types.CREATE_REQUEST_STUDENT_ERROR:
      return {
        ...state,
        isCreatingStudent: action.isCreatingStudent,
        createStudentError: action.createStudentError
      }

    case types.SET_REQUEST_STUDENT_REQUEST:
      return {
        ...state,
        isFetchingWorkProcess: action.isFetchingWorkProcess
      };
    case types.SET_REQUEST_STUDENT_COMPLETED:
      return {
        ...state,
        isFetchingWorkProcess: action.isFetchingWorkProcess,
        workProcess: action.workProcess
      };
    case types.SET_REQUEST_STUDENT_ERROR:
      return {
        ...state,
        isFetchingWorkProcess: action.isFetchingWorkProcess,
        workProcessError: action.workProcessError
      };

    case types.CREATE_REQUEST_PERSON_REQUEST:
      return {
        ...state,
        isCreatingPerson: action.isCreatingPerson
      }

    case types.CREATE_REQUEST_PERSON_COMPLETED:
      return {
        ...state,
        isCreatingPerson: action.isCreatingPerson,
        createdPerson: action.createdPerson
      }

    case types.CREATE_REQUEST_PERSON_ERROR:
      return {
        ...state,
        isCreatingPerson: action.isCreatingPerson,
        createPersonError: action.createPersonError
      }

    case types.CALCULATE_REQUEST_SIMILAR_REQUEST:
      return {
        ...state,
        isCalculatingSimilarRequest: action.isCalculatingSimilarRequest,
        calcSimilarResult: null
      }

    case types.CALCULATE_REQUEST_SIMILAR_COMPLETED:
      return {
        ...state,
        isCalculatingSimilarRequest: action.isCalculatingSimilarRequest,
        calcSimilarResult: action.calcSimilarResult
      }

    case types.CALCULATE_REQUEST_SIMILAR_ERROR:
      return {
        ...state,
        isCalculatingSimilarRequest: action.isCalculatingSimilarRequest,
        calcSimilarError: action.calcSimilarError
      }

    case types.GET_REQUEST_PROGRAM_FILTERS_REQUEST:
      return {
        ...state,
        isFetchingFilters: action.isFetchingFilters,
        filters: null
      }

    case types.GET_REQUEST_PROGRAM_FILTERS_COMPLETED:
      return {
        ...state,
        isFetchingFilters: action.isFetchingFilters,
        filters: action.filters
      }

    case types.GET_REQUEST_PROGRAM_FILTERS_ERROR:
      return {
        ...state,
        isFetchingFilters: action.isFetchingFilters,
        filtersError: action.filtersError
      }

    case types.CREATE_REQUEST_PROGRAM_REQUEST:
      return {
        ...state,
        isCreatingRequestProgram: action.isCreatingRequestProgram,
        createdRequestProgram: null
      }

    case types.CREATE_REQUEST_PROGRAM_COMPLETED:
      return {
        ...state,
        isCreatingRequestProgram: action.isCreatingRequestProgram,
        createdRequestProgram: action.createdRequestProgram
      }

    case types.CREATE_REQUEST_PROGRAM_ERROR:
      return {
        ...state,
        isCreatingRequestProgram: action.isCreatingRequestProgram,
        createRequestProgramError: action.createRequestProgramError
      }

    default:
      return state;
  }
}
